<form (ngSubmit)="onAddArticle(articleForm)" #articleForm="ngForm">
  <div class="grid-x grid-margin-x">
    <div class="large-6 small-12">
      <label for="title">Title</label>
      <input type="text" id="title" name="title" required [(ngModel)]="formData.title" >
    </div>
    <div class="large-4 small-8">
      <label for="bg">Select background</label>
      <select name="bg" id="bg" [(ngModel)]="formData.bg">
        <option value="home">Black Piano</option>
        <option value="bg2">Light Piano</option>
        <option value="dark">Dark</option>
        <option value="piano-goldwork">Piano Goldwork</option>
        <option value="string-casing">String Casings</option>
        <option value="restringing">Restringing</option>
        <option value="keybed">Keybeds</option>
        <option value="action">Action on wall</option>
        <option value="steinway-polished">Steinway Polished</option>
        <option value="kate-working">Kate Working</option>
        <option value="kate-mopping">Kate Mopping</option>
        <option value="aiden-working">Aiden Working</option>
        <option value="adjustments">Adjustments</option>
      </select>
    </div>
    <div class="large-2 small-4">
      <label for="order">Place in list</label>
      <input type="text" id="order" name="order" required [(ngModel)]="formData.order" >
    </div>
  </div>

  <label for="content">Area Content</label>
  <textarea [(ngModel)]="formData.content" name="content" id="content" cols="30" rows="10"></textarea>
  <label for="imageIsFile">Image from link</label>
  <input type="checkbox" id="imageIsFile" name="imageIsFile" [(ngModel)]="formData.imageIsFile">
  @if (!formData.imageIsFile) {
    <div class="image-upload">
      <input type="file" id="fileElem"
        accept="image/*"
        (change)="addImage($event)">
    </div>
  }
  @if (formData.imageIsFile) {
    <div class="file-link">
      <label for="fileLink">File link</label>
      <input type="text" id="fileLink" name="fileLink" [(ngModel)]="formData.fileLink" >
    </div>
  }
  <div class="title-container">
    <div class="image-header"><h4>Selected Images</h4></div>
    <div class="image-header"><h4>Available images</h4></div>
  </div>
  <div class="images-container">
    <div class="selected-images">
      @for (img of selectedImages; track img.path) {
        <div class="available-image selected-image"
          (click)="removeImage(img)"
          [ngStyle]="{'background-image': 'url(' + (img.imageDownloadPath | async) + ')'}">
        </div>
      }
    </div>
    <app-image-picker class="available-images"
      [images]="images"
      [selectedPaths]="selectedPaths"
      (select)="selectImage($event)"
      (deleted)="onImageDeleted($event)">
    </app-image-picker>
  </div>
  <button class="button" type="submit" [disabled]="!articleForm.valid">Save</button>
</form>
